import React from 'react';
import {MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class Badges extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: []
		}
	}

	GetParams(){
		let params = new URLSearchParams()

		if(this.props.date){
			params.set("date", this.props.date)
		}
		if(this.props.acct){
			params.set("acct", this.props.acct)
		}
		params.set("token", this.props.auth.token)
		params.set("user", this.props.auth.user)
		return params.toString()
	}

	componentWillMount(){
		let self = this
		const apiClient = createApiClient();
		apiClient.get(MWBaseURL()+"earned_badges?"+self.GetParams())
		.then(data => {
			this.setState({data : data})
		}).catch(e => console.log(e));
	}


	render(){
		let self = this
		let tracBase = process.env.REACT_APP_RE_AUTH_URL.slice(0, process.env.REACT_APP_RE_AUTH_URL.lastIndexOf("/")+1)
		let tracUrl = tracBase+"achievements.action?selectedAcct="+self.props.acct
		let images = self.state.data.slice(0, 3).map((x, i) => (
			<a href={tracUrl} target="_blank" rel="noreferrer" key={x.name}><img alt={x.name} src={`${tracBase}images/badges/${x.name}.png`} width="70" height="70" title={x.display_name} style={{cursor: "pointer", position: "absolute", left: i*75+"px"}}/></a>
		));

		return (
			<div className="col-lg-2 ml-auto">
			<div className="row mt-1 font-weight-bold text-muted">{self.state.data.length > 0 ? "Achievements ("+self.state.data.length+")" : ""}</div>
			<div className="row mt-1">{images}</div>
			</div>
		)
	}
}
export default Badges;